export class AdminSubscriptionCompanyEmployee {
  employeeId: number
  name: string
  email: string
  phone: string
  companyFunction: string
  isMaster: boolean
  status: string
  permissionsCount: number
  permissions: string[]

  constructor(data: Partial<AdminSubscriptionCompanyEmployee> = {}) {
    this.employeeId = data.employeeId ?? 0

    this.name = data.name ?? ""

    this.email = data.email ?? ""

    this.phone = data.phone ?? ""

    this.companyFunction = data.companyFunction ?? ""

    this.isMaster = data.isMaster ?? false

    this.status = data.status ?? ""

    this.permissionsCount = data.permissionsCount ?? 0

    this.permissions = data.permissions ?? []
  }
}
